
export const combineClasses = (...classes) => {
    return classes.join(" ")
}

export const getToken = () => {
    return localStorage.getItem("token")
}

export const dateConverter = (str) => {
    // const date = str.toString().split(" ");
    // return [months[date[1]], date[3]].join("/");
    const d = new Date(str)
    let mm = d.getMonth() + 1;
    let dd = d.getDate();

    return [
        (dd > 9 ? '' : '0') + dd,
        (mm > 9 ? '' : '0') + mm,
        d.getFullYear(),
    ].join('/');
}

export const processArray = async (arr, baseUrl) => {
    for (let i = 0; i < arr.length; i++) {
        const url = baseUrl ? baseUrl + arr[i] : arr[i];

        if (url) {
            const filename = url.substring(url.lastIndexOf('/') + 1);
            const link = document.createElement("a");
            link.href = url;
            // link.download = true;
            link.download = filename;
            document.body.appendChild(link); // Required for Firefox
            link.click();
            document.body.removeChild(link);
            await new Promise((res) => {
                setTimeout(() => {
                    res();
                }, 1000);
            });
        }
    }
};

export const downloadFile = (url,fileName) =>{
    console.log("first")
    const link = document.createElement('a');
    link.setAttribute("href", url);
    if(fileName) {
        link.setAttribute("download", fileName);
    }
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
